export default function () {
    return {
        accounts: [],
        sub_users: [],
        selected_user: null,
        selected_account: null,
        selected_account_info: null,
        selected_sub_user: null,
        credit_consumption_detail: null,
        right_tab_of_modal: null,
        left_tab_of_modal: null,
    };
}
